import httpClient from '@/libs/http-client'

export function saveUt (params) {
  const url = '/ut/save_ut'

  return httpClient.post(url, params).then(response => {
    return response.data.result
  })
}

export function getUt (params) {
  const url = '/ut/get/' + params.utid

  return httpClient.get(url).then(response => {
    return response.data
  })
}

export function deleteUt (params) {
  const url = '/ut/delete_ut'

  return httpClient.post(url, params).then(response => {
    return response.data
  })
}

export function setStateChangeUt (params) {
  const url = '/ut/set_ut_state'

  return httpClient.post(url, params).then(response => {
    return response.data
  })
}

export function saveSurvey (params) {
  const url = '/ut/save_survey'

  return httpClient.post(url, params).then(response => {
    return response.data
  })
}

export function imageUpload (params) {
  const url = '/ut/image_upload'

  return httpClient.post(url, params).then(response => {
    return response.data
  })
}

export function getUtResult (params) {
  const url = '/ut/survey_summary/' + params.utid

  return httpClient.get(url).then(response => {
    return response.data
  })
}

export function getUtResultVisit (params) {
  const url = '/es/get_ut_pv'

  return httpClient.post(url, params).then(response => {
    return response.data
  })
}
